import React from "react";
import styles from "./Loader.module.scss";

interface LoaderProps {
  color?: string;
  size?: number;
  borderWidth?: number;
}

const Loader: React.FC<LoaderProps> = ({
  color = "#fff",
  size = 30,
  borderWidth = 3,
}) => {
  const loaderStyle = {
    "--color": color,
    "--size": `${size}px`,
    "--border": `${borderWidth}px`,
  } as React.CSSProperties;

  return <div className={styles.loader} style={loaderStyle}></div>;
};

export default Loader;
